import { searchParam, useSetSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';
import { z } from 'zod/v4';

import { comparisonTabs } from '@/areas/comparison/Comparison/components/ComparisonTable/comparisonTabs';
import { SourcingComparisonPage } from '@/areas/comparison/Comparison/SourcingComparisonPage/SourcingComparisonPage';
import { sourcingViewModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/projects/$projectId/sourcing/_sidebar/compare')({
    staticData: {
        access: { permissions: ['view:sourcing'], modulePermissions: sourcingViewModulePermissions },
        chrome: 'project',
    } satisfies PageStaticData,
    validateSearch: z.object({
        baseline: z.string().optional(),
        referenceA: z.string().optional(),
        referenceB: z.string().optional(),
        tab: searchParam.enum(comparisonTabs, 'optional'),
    }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    const tab = Route.useSearch({ select: (search) => search.tab });
    const setSearch = useSetSearch();
    return <SourcingComparisonPage {...pathParams} tab={tab} onSearchChange={setSearch} />;
}
